import { render, staticRenderFns } from "./ErrorPageForm.vue?vue&type=template&id=79b9acf8&"
import script from "./ErrorPageForm.vue?vue&type=script&lang=js&"
export * from "./ErrorPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports